module.exports = __webpack_public_path__ + "img/magic-bus-company.f5def8a8.png";